// @flow

import React from 'react';
import placeholderImage from 'img/fallback/logo_image_item_file_default.png';
import addFilterParams from 'helpers/addFilterParams';
import TrackEvent from 'components/TrackEvent';

type Props = {
  job: {
    id: number | string,
    title: string,
    pageUrl: string,
    company: any,
    logoImageItem: any,
    workType: any,
  },
  index: number,
  trackEventName: string,
  trackClickName: string
};

export default ({
  job: {
    id,
    title,
    pageUrl,
    company,
    logoImageItem,
    workType
  },
  index,
  trackEventName,
  trackClickName
}: Props) => {
  const proper_url = addFilterParams(pageUrl, index);
  const trackProperties = JSON.stringify({
    event: trackClickName,
    properties: {
      job_id: id,
      company_id: company.id,
      company_name: company.name
    }
  });

  return (
    <div className="card card_job">
      <a href={proper_url} title={title} className="card__img" data-track={trackProperties}>
        <img
          src={logoImageItem && logoImageItem.file ? logoImageItem.file.profile.url : placeholderImage}
          title={logoImageItem ? logoImageItem.title : title}
          alt={logoImageItem ? logoImageItem.title : title}
        />
      </a>
      <div className="card__overview">
        <a href={proper_url} className="card__title" data-track={trackProperties}>{title}</a>
        <div className="card__info_item icon-clock-o">{workType.name}</div>
      </div>
      <TrackEvent name={trackEventName} properties={{
        job_id: id,
        company_id: company.id,
        company_name: company.name
      }}/>
    </div>
  );
};
